import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";

// Páginas públicas
import Home from "./pages/public/Home";
import Listado from "./pages/public/Listado";
import Detalle from "./pages/public/Detalle";
import SobreNosotros from "./pages/public/SobreNosotros";
import VenderPropiedad from "./pages/public/VenderPropiedad";

// Páginas admin
import Login from "./pages/admin/Login";
import Dashboard from "./pages/admin/Dashboard";
import Propiedades from "./pages/admin/Propiedades";
import FormPropiedad from "./pages/admin/FormPropiedad";
import Consultas from "./pages/admin/Consultas";
import Ingresos from "./pages/admin/Ingresos";

function RutaProtegida({ children }) {
  const { usuario } = useAuth();
  return usuario ? children : <Navigate to="/admin/login" />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/propiedades" element={<Listado />} />
        <Route path="/propiedades/:id" element={<Detalle />} />
        <Route path="/sobre-nosotros" element={<SobreNosotros />} />
        <Route path="/vender" element={<VenderPropiedad />} />

        <Route path="/admin/login" element={<Login />} />
        <Route path="/admin" element={<RutaProtegida><Dashboard /></RutaProtegida>} />
        <Route path="/admin/propiedades" element={<RutaProtegida><Propiedades /></RutaProtegida>} />
        <Route path="/admin/propiedades/nueva" element={<RutaProtegida><FormPropiedad /></RutaProtegida>} />
        <Route path="/admin/propiedades/editar/:id" element={<RutaProtegida><FormPropiedad /></RutaProtegida>} />
        <Route path="/admin/consultas" element={<RutaProtegida><Consultas /></RutaProtegida>} />
        <Route path="/admin/ingresos" element={<RutaProtegida><Ingresos /></RutaProtegida>} />
      </Routes>
    </BrowserRouter>
  );
}